import { useLang } from '@/i18n';
import EcoLink from 'eco-design/base/eco-link';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import { useRouter } from 'next/router';
import styles from './index.module.scss';

export default function SectionA5() {
    const { locale = 'us' } = useRouter();
    const { t } = useLang('delta_pro_ultra.launch.detail.SectionA5');

    const specData = {
        headers: [
            { name: t('item1_name'), image: 'https://websiteoss.ecoflow.com/upload/image/1750237783373/product1.png' },
            { name: t('item2_name'), image: 'https://websiteoss.ecoflow.com/upload/image/1750237739031/product2.png' },
            { name: t('item3_name'), image: 'https://websiteoss.ecoflow.com/upload/image/1750237738440/product3.png' },
        ],
        specs: [
            { title: t('label1'), items: [t('item1_tag_1'), t('item2_tag_1'), t('item3_tag_1')] },
            { title: t('label2'), items: [t('item1_tag_2'), t('item2_tag_2'), t('item3_tag_2')] },
            { title: t('label3'), items: [t('item1_tag_3'), t('item2_tag_3'), t('item3_tag_3')] },
            { title: t('label4'), items: [t('item1_tag_4'), t('item2_tag_4'), t('item3_tag_4')] },
            { title: t('label5'), items: [t('item1_tag_5'), t('item2_tag_5'), t('item3_tag_5')] },
            { title: t('label6'), items: [t('item1_tag_6'), t('item2_tag_6'), t('item3_tag_6')] },
            { title: t('label7'), items: [t('item1_tag_7'), t('item2_tag_7'), t('item3_tag_7')] },
            { title: t('label8'), items: [t('item1_tag_8'), t('item2_tag_8'), t('item3_tag_8')] },
        ],
    };

    return (
        <div className={`page-SectionA5 ${styles.SectionA5}`}>
            <EcoSpace />
            <EcoSectionCommon title={t('title')} />
            <EcoSpaceSmall />
            <div className={`eco-content ${styles.SectionA5}`}>
                <div className="spec-table-wrapper">
                    <table className="spec-table">
                        <thead>
                            <tr>
                                <th></th>
                                {specData.headers.map((header, index) => (
                                    <th key={index}>
                                        <div className="product-info">
                                            {header.image && (
                                                <div className="product-image">
                                                    <img src={header.image} alt={header.name} />
                                                </div>
                                            )}
                                            <div className="product-name">{header.name}</div>
                                        </div>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {specData.specs.map((spec, index) => (
                                <tr key={index}>
                                    <td className="spec-title">{spec.title}</td>
                                    {spec.items.map((item, itemIndex) => (
                                        <>
                                            <td key={itemIndex}>
                                                {itemIndex === 1 && <div className="cell-item-title">{spec.title}</div>}
                                                {item}
                                            </td>
                                        </>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <EcoSpaceSmall />
                <EcoLink
                    className="info-link"
                    href={`https://${locale}.ecoflow.com/products/delta-pro-ultra`}
                    dataLayer={{
                        event: 'uaEvent',
                        event_name: 'buy',
                        product_name: t('title'),
                        position: 'Product Detail',
                    }}
                >
                    {t('btn')}
                </EcoLink>
            </div>
            <EcoSpace />
        </div>
    );
}
